<div
    [attr.data-testId]="section().id"
    [attr.data-styletarget]="section().id"
    [id]="section().id"
    [attr.data-uitype]="'builder-section'"
    [class.border-t-dat-grey-100]="section().title?.length <= 0"
    [class.border-t-white]="section().title?.length > 0"
    [class.border-none]="section()?.type === 'Collapsible'"
    class="bg-white border border-x-dat-grey-100 border-b-dat-grey-100"
>
    @for (component of section().components; track component?.id; let idx =
    $index) {

    <iq-style-processor-show-element
        [id]="component?.id + '-style-processor'"
        [rules]="component?.rules"
        [iqStyleProcessorClassname]="component.classNames"
        [cssClassRules]="component.cssClassRules"
        (evaluated)="setRunRules(component.id, $event)"
        [runRules]="ruleStatus()?.[component.id]"
    >
        <iq-builder-component
            [dashboardId]="dashboardId"
            [id]="component?.id"
            [sectionId]="id"
            [component]="component"
        ></iq-builder-component>
    </iq-style-processor-show-element>
    }
</div>
